import moment from "moment";
let count_time_difference = (date1, date2) => {
  let start = moment(new Date(date1));
  let end = moment(new Date(date2));
  let duration = moment.duration(end.diff(start));

  return parseInt(duration.asMinutes());
};
export default count_time_difference;
